import { render, staticRenderFns } from "./UserCms.vue?vue&type=template&id=6c563f3e&"
import script from "./UserCms.vue?vue&type=script&lang=js&"
export * from "./UserCms.vue?vue&type=script&lang=js&"
import style0 from "./UserCms.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports